var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ListSectionValueEditor',{staticClass:"ListSectionValueEditor__publication",attrs:{"index":_vm.index,"content":_vm.documentName,"listType":"ul"}})
}
var staticRenderFns = []

export { render, staticRenderFns }